import * as React from 'react';
export const sabadellSvg = React.forwardRef(function sabadellSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#09C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          transform: 'translate(1.73 4.324)',
        },
        /*#__PURE__*/ React.createElement('ellipse', {
          cx: 6.07,
          cy: 6.05,
          fill: '#25221F',
          rx: 5.99,
          ry: 5.97,
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'm26.27 7.24-3.49 1.15c-.5-1.48-1.46-2.07-3.02-2.07-1.1 0-2.44.28-2.44 1.63 0 1.28 1.54 1.59 2.54 1.77 1.44.3 3.36.66 4.59 1.48 1.43.95 2.3 2.4 2.3 4.14a5.6 5.6 0 0 1-2.17 4.4c-1.41 1.1-3.34 1.43-5.1 1.43-3.31 0-6.3-1.43-7.1-4.86l3.79-.87c.51 1.84 1.85 2.48 3.67 2.48 1.17 0 2.74-.43 2.74-1.89s-2-1.74-3.08-1.97c-3.13-.64-6.2-1.56-6.2-5.4a5.2 5.2 0 0 1 1.9-4.1 6.58 6.58 0 0 1 4.4-1.44c3.08 0 5.6 1.08 6.67 4.12zM3.87 3.42h2.46c.43 0 .88 0 1.26.24.44.28.67.68.67 1.2 0 .63-.41 1.04-1 1.18v.02c.7.14 1.15.65 1.15 1.37 0 .48-.28.9-.67 1.18-.4.3-.94.3-1.4.3H3.86v-5.5zm1.28 3.15V7.9h.9c.23 0 .52.02.72-.12a.68.68 0 0 0 .3-.57c0-.2-.14-.42-.32-.52-.19-.1-.44-.1-.65-.1h-.95zm0-2.17v1.2h.88c.22 0 .49.01.68-.13a.63.63 0 0 0 .23-.5c0-.2-.1-.39-.27-.5-.19-.1-.52-.07-.74-.07h-.78z',
        }),
      ),
    ),
  );
});
sabadellSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var sabadell = {
  category: 'brand',
  colorable: false,
  name: 'sabadell',
  svg: sabadellSvg,
};
